import React from 'react';
import { motion } from "framer-motion";
import { FaEye, FaShoppingCart } from "react-icons/fa";

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.55, type: "spring", bounce: 0.22 } }
};

const ProductCard = ({ product, onAddToCart, onViewDetail }) => {
  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <svg
          key={i}
          className={`w-4 h-4 ${i <= rating ? 'text-yellowStar' : 'text-gray-300'}`}
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.538 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.783.57-1.838-.197-1.538-1.118l1.07-3.292a1 1 0 00-.364-1.118l-2.8-2.034c-.783-.57-.38-1.81.588-1.81h3.462a1 1 0 00.95-.69l1.07-3.292z" />
        </svg>
      );
    }
    return stars;
  };

  return (
    <motion.div
      className="bg-white/30 backdrop-blur-md border border-white/20 rounded-xl shadow-md hover:shadow-2xl transition-all duration-300 transform hover:scale-[1.025] overflow-hidden min-h-[330px] flex flex-col justify-between"
      variants={cardVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.24 }}
      whileHover={{ scale: 1.03, boxShadow: "0 12px 32px 0 rgba(38,110,255,0.11)" }}
    >
      <img
        src={product.image || 'https://via.placeholder.com/300x200?text=Sin+imagen'}
        alt={product.name}
        className="w-full h-48 object-cover rounded-t-xl bg-gray-100"
      />
      <div className="p-4 flex flex-col justify-between flex-grow">
        <h3 className="text-lg font-semibold text-deepBlue mb-1">{product.name}</h3>

        <div className="flex items-center text-sm text-yellow-500 mb-2">
          {renderStars(product.rating)}
          <span className="ml-2 text-gray-500 text-xs">({product.reviews})</span>
        </div>

        <p className="text-sm text-gray-700 mb-3 line-clamp-2">{product.description}</p>

        <div className="flex justify-between items-center mt-4">
<span className="text-xl font-bold text-primary">
  {Number(product.price).toLocaleString("es-CO", { style: "currency", currency: "COP", minimumFractionDigits: 0 })}
</span>

          <div className="flex space-x-2">
<button
  title="Ver detalles"
  onClick={() => onViewDetail(product)}
  className="p-2 rounded-full bg-blue-600 hover:bg-blue-700 text-white shadow-md transition-all"
>
  <FaEye className="w-5 h-5" />
</button>
            <button
              title="Agregar al carrito"
              onClick={() => onAddToCart(product)}
              className="p-2 rounded-full bg-green-500 hover:bg-green-600 text-white shadow-md transition-all"
            >
              <FaShoppingCart className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ProductCard;
